<template>
    <div class="email-broadcast-list">
        <div class="toolbar-container">
            <EmailBroadcastFilterToolbar v-model="filters" />
            <!-- Diğer araç çubuğu bileşenleri -->
        </div>
        <div class="toolbar-container">
            <div class="view-switcher">
                <div class="supsis-button-group">
                    <SupsisButton @click="setMode('active')" :primary="mode === 'active'" small> Active</SupsisButton>
                    <SupsisButton @click="setMode('archived')" :primary="mode === 'archived'" small>
                        Archived
                    </SupsisButton>
                </div>
            </div>
        </div>
        <supsis-table :columns="columns" :data="emailBroadcasts" :loading="loading" @change="onTableChange" />
    </div>
</template>

<script>
import Vue from "vue";
import SupsisTable from "../../../../components/SupsisTable.vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import { MAIL_API } from "../../../../api/mail";
import EmailBroadcastFilterToolbar from "./EmailBroadcastFilterToolbar.vue";

export default Vue.extend({
    components: { SupsisButton, SupsisTable, EmailBroadcastFilterToolbar },
    data() {
        return {
            mode: "active",
            emailBroadcasts: [],
            loading: false,
            paginationCursor: {
                page: 1,
                perPage: 10,
                total: 0,
            },
            filters: [],
        };
    },
    computed: {
        columns() {
            return [
                {
                    title: "ID",
                    dataIndex: "_id",
                    key: "_id",
                },
                {
                    title: "Subject",
                    dataIndex: "subject",
                    key: "subject",
                },
                {
                    title: "Created At",
                    dataIndex: "createdAt",
                    key: "createdAt",
                },
                // Diğer sütunlar...
            ];
        },
    },
    methods: {
        setMode(newMode) {
            this.mode = newMode;
            this.paginationCursor.page = 1;
            this.fetch();
        },
        async fetch() {
            this.loading = true;
            const cursor = {
                limit: this.paginationCursor.perPage,
                skip: (this.paginationCursor.page - 1) * this.paginationCursor.perPage,
            };
            try {
                let response;
                if (this.mode === "active") {
                    response = await MAIL_API.BROADCAST.listActivePaginated(cursor);
                } else {
                    response = await MAIL_API.BROADCAST.listArchivedPaginated(cursor);
                }
                this.emailBroadcasts = response.items;
                this.paginationCursor.total = response.count;
            } catch (error) {
                console.error("Error fetching email broadcasts:", error);
            } finally {
                this.loading = false;
            }
        },
        onTableChange(pagination) {
            this.paginationCursor.page = pagination.current;
            this.paginationCursor.perPage = pagination.pageSize;
            this.fetch();
        },
    },
    mounted() {
        this.fetch();
    },
});
</script>

<style lang="scss">
.email-broadcast-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .toolbar-container {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 10px;
    }
}
</style>
